import clsx from 'clsx';

import styles from './LegacyMenu.module.scss';

export type Props = {
  /**
   * Accessibility label that describes the options available inside the
   * menu, e.g. "List of items", "List of Countries", etc.
   */
  'aria-label': string;
  /**
   * Items to render within the `Menu`.
   */
  children: React.ReactNode;
  /**
   * Optional property for overriding styles with CSS-in-JS or defining a custom class.
   * */
  className?: string;
  /**
   * The `id` for the menu so it can be properly referenced.
   */
  id?: string;
  /**
   * The optional a11y role for the menu. `menu` is the semantic equivalent of `<ul>`
   *  and should be used when the children have a role of `menuitem`,
   *  while `listbox` is the semantic equivalent of `<select>` and
   *  should be used when the children have the role of `option`.
   */
  role?: 'listbox' | 'menu';
};

/**
 * <span style="color: #a81227; font-weight: bold;">⚠️ This component is deprecated in favor of [BetaMenuTriggerRoot](https://zinnia-storybook.zapier.com/?path=/docs/forms-betamenutrigger--docs).</span>
 *
 * Renders a list of items within a scrollable container.
 *
 * @deprecated Use `BetaMenuTriggerRoot` instead.
 */
export const LegacyMenu = ({ children, className, role, ...props }: Props) => {
  return (
    <ul
      role={role}
      aria-label={props['aria-label']}
      className={clsx(styles.root, className)}
      data-zds
    >
      {children}
    </ul>
  );
};
